// automatically set event binding to class
export { default as bindEvents } from './bind-events';

// limit a number to a range
export { default as clamp } from './clamp';

// feature and browser detection
export { default as detectTouch } from './detect-touch';

// easing equations
export { default as easing } from './easing';

// get element index from parent (default) or provided haystack
export { default as getElementIndex } from './get-element-index';

// get element offset dimensions
export { default as getOffsetBounds } from './get-offset-bounds';

// get top/left positions relative to root or parent
export { default as getRootOffset } from './get-root-offset';

// get comprehensive dimensions relative to root or parent
export { default as getRootOffsetBounds } from './get-root-offset-bounds';

// get element scroll position (relative to top and left of viewport)
export { default as getScrollPosition } from './get-scroll-position';

// lodash functions
export { default as lodash } from './lodash';

// media queries (matches @mixin mq from breakpoints.scss)
export { default as mq } from './mq';

// multiple targets classlist methods
export { default as multiClassList } from './multi-class-list';

// multiple targets add and remove listeners
export { default as multiAddEventListener } from './multi-add-event-listener';
export { default as multiRemoveEventListener } from './multi-remove-event-listener';

// remove class(es) starting with a prefix
export { default as removeClassByPrefix } from './remove-class-by-prefix';

// double wrap split-text lines or words (for masking effects, for example)
export { default as splitTextDoubleWrap } from './split-text-double-wrap';
